import type { ReactNode } from 'react'

type Props = {
  loading?: boolean
  children?: ReactNode
  minHeight?: string
}

export default function LoadingOverlay({ loading = true, children, minHeight }: Props) {
  return (
    <div
      className={`content-loading-wrapper${loading ? ' content-loading-wrapper--loading' : ''}`}
      style={minHeight ? { minHeight } : undefined}
    >
      {loading && (
        <div className="loading-overlay">
          <div className="page-spinner" />
        </div>
      )}
      {children}
    </div>
  )
}
